const catstore = function reducer(
	state = {
		catstore: [],
		filterIcons: [],
		categoryList: [],
		fetching: false,
		fetched: false,
		error: null
	},
	action
) {
	switch (action.type) {
		case 'FETCH_CAT': {
			return { ...state, fetching: true }
		}
		case 'FETCH_CAT_FULFILLED': {
			return {
				...state,
				fetching: true,
				fetched: true,
				catstore: action.payload,
				filterIcons: action.filterIcons,
				categoryList: action.categoryList
			}
		}
	}
	return state
}
export default catstore
